import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './StripeError.module.css';
import { useLanguage } from '../Providers/LanguageContext';

function StripeError() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.icon}>❌</div>
        <h1 className={styles.title}>{t('stripe.errorTitle')}</h1>
        <p className={styles.subtitle}>
          {t('stripe.errorMessage')}
        </p>

        <div className={styles.content}>
          <h2 className={styles.sectionTitle}>{t('stripe.whatHappened')}</h2>
          <p className={styles.text}>
            {t('stripe.notCompleted')}
          </p>
          <ul className={styles.reasonsList}>
            <li>{t('stripe.reasons.cancelled')}</li>
            <li>{t('stripe.reasons.declined')}</li>
            <li>{t('stripe.reasons.connection')}</li>
            <li>{t('stripe.reasons.expired')}</li>
          </ul>

          <h2 className={styles.sectionTitle}>{t('stripe.whatToDo')}</h2>
          <div className={styles.actionsList}>
            <div className={styles.actionItem}>
              <span className={styles.actionIcon}>💳</span>
              <div>
                <strong>{t('stripe.actions.tryDifferentCard')}</strong>
                <p>{t('stripe.actions.tryDifferentCardDesc')}</p>
              </div>
            </div>
            <div className={styles.actionItem}>
              <span className={styles.actionIcon}>🔄</span>
              <div>
                <strong>{t('stripe.actions.retryPayment')}</strong>
                <p>{t('stripe.actions.retryPaymentDesc')}</p>
              </div>
            </div>
            <div className={styles.actionItem}>
              <span className={styles.actionIcon}>🏦</span>
              <div>
                <strong>{t('stripe.actions.checkBank')}</strong>
                <p>{t('stripe.actions.checkBankDesc')}</p>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.buttonContainer}>
          <button
            className={styles.primaryButton}
            onClick={() => navigate('/main')}
          >
            {t('stripe.tryAgain')}
          </button>
          <button
            className={styles.secondaryButton}
            onClick={() => navigate('/main')}
          >
            {t('stripe.returnHome')}
          </button>
        </div>

        <p className={styles.helpText}>
          {t('stripe.contactSupport')}
        </p>
      </div>
    </div>
  );
}

export default StripeError;
